import { render, staticRenderFns } from "./SelectedUBAsList.vue?vue&type=template&id=6a3d653c&scoped=true&"
import script from "./SelectedUBAsList.vue?vue&type=script&lang=js&"
export * from "./SelectedUBAsList.vue?vue&type=script&lang=js&"
import style0 from "./SelectedUBAsList.vue?vue&type=style&index=0&id=6a3d653c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3d653c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
